import type { MouseEvent } from "react";

/**
 * Otwiera link zewnętrzny w nowej karcie. W osadzonym podglądzie (iframe)
 * target="_blank" bywa blokowany, więc robimy fallback na nawigację top-level.
 */
export function openExternal(e: MouseEvent<HTMLAnchorElement>, url: string) {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
  e.preventDefault();
  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win) {
    try {
      (window.top ?? window).location.href = url;
    } catch {
      window.location.href = url;
    }
  }
}
